<template>
  <div>
    <br />
    <div class="row px-2">
      <div :class="errors != [] ? 'rounded bg-white border' : ''">
        <div v-for="(error, index) in errors" :key="index++" class="col-12">
          <div class="text-danger py-1">
            {{ index + " - " + error }}
          </div>
        </div>
      </div>
    </div>

    <form @submit.prevent="save(saleItem)">
      <div class="row align-items-end">
        <!-- <div class="col-xl-3 col-12 my-3">
          <label for="">Catégorie</label>
          <vue-select
            :options="sections"
            v-model="section_reference"
            placeholder="Select an option"
            labelColumn="fullName"
            valueColumn="reference"
          />
        </div> -->

        <div class="col-xl-4 col-12 my-3">
          <label for="itemInput">Produit</label>

          <vue-select
            :options="filteredItems"
            v-model="saleItem.item_reference"
            placeholder="Select an option"
            labelColumn="fullName"
            valueColumn="reference"
          />
        </div>

        <div v-if="shouldShowStockQuantity" class="col-xl-2 col-12 my-3">
          <label for="">Stock disponible</label>
          <input
            :value="
              availableStockQuantity !== null
                ? availableStockQuantity +
                  (selectedItemMeasuring ? ' ' + selectedItemMeasuring : '') +
                  (isMultipleStock &&
                  saleItem.stock_reference &&
                  selectedStockQuantity !== null
                    ? ' (Sélectionné: ' + selectedStockQuantity + ')'
                    : '')
                : '0'
            "
            disabled
            class="form-control"
          />
        </div>

        <!-- <div  class="col-xl-2 col-12 my-3">
          <label for=""> Prix d'achat TTC </label>
          <input
            v-if="Object.keys(filteredStockItems).length == 1"
            :value="filteredStockItems[0].purchasePriceTTC + ' DIRHAMS'"
            disabled
            class="form-control"
          />
          <input v-else :value="' '" disabled class="form-control" />
        </div> -->

        <!-- <div class="col-xl-2 col-12 my-3">
          <label>Prix d'achat TTC</label>
          <input
            :value="singlePurchasePriceTTC"
            disabled
            class="form-control"
          />
        </div> -->

        <div v-if="isMultipleStock" class="col-xl-3 col-12 my-3">
          <label for=""> Stock <span class="text-danger">*</span> </label>
          <select
            v-model="saleItem.stock_reference"
            class="form-select"
            :class="{
              'is-invalid':
                isMultipleStock &&
                !saleItem.stock_reference &&
                saleItem.item_reference,
            }"
          >
            <option value="">Sélectionner un stock</option>
            <option
              v-for="(stock, index) in filteredStockItems"
              :key="index"
              :value="stock.reference"
            >
              {{ stock.stockFullName }} - Quantité :
              {{ parseFloat(stock.quantity || 0).toFixed(2) }}
              {{ stock.measuring }}
            </option>
          </select>
          <div
            v-if="
              isMultipleStock &&
              !saleItem.stock_reference &&
              saleItem.item_reference &&
              filteredStockItems &&
              filteredStockItems.length > 0
            "
            class="invalid-feedback"
          >
            Veuillez sélectionner un stock
          </div>
        </div>

        <div class="col-xl-2 col-6 my-3">
          <label for="">Quantité </label>
          <input
            v-model="saleItem.quantity"
            type="text"
            :max="
              shouldShowStockQuantity && availableStockQuantity !== null
                ? parseFloat(availableStockQuantity)
                : null
            "
            step="0.01"
            :class="[
              'form-control',
              { 'is-invalid': isQuantityExceedingStock },
            ]"
            @input="validateQuantity"
          />
          <div v-if="isQuantityExceedingStock" class="invalid-feedback">
            La quantité ne peut pas dépasser le stock disponible ({{
              availableStockQuantity
            }}
            {{ selectedItemMeasuring || "" }})
          </div>
        </div>

        <div class="col-xl-2 col-6 my-3">
          <label for="">Quantité (Unites) </label>
          <input v-model="saleItem.pcs" type="text" class="form-control" />
        </div>

        <div class="col-xl-2 col-6 my-3">
          <label for="">Prix U </label>
          <input v-model="saleItem.priceTTC" class="form-control" />
        </div>

        <div class="col-xl col-12 my-3">
          <label for=""> Remarque </label>
          <input v-model="saleItem.remark" class="form-control" />
        </div>
      </div>

      <hr />
      <div class="row justify-content-end">
        <div class="col-xl-auto col-6">
          <label for=""></label>
          <button class="btn btn-success shadow" type="submit">
            <i class="bi bi-plus-circle"></i> Insérer
          </button>
        </div>

        <div class="col-xl-auto col-6">
          <label for=""></label>
          <button
            type="button"
            class="btn btn-secondary d-flex align-items-center"
            @click="refresh()"
          >
            <i class="bi bi-arrow-clockwise fs-4 me-2"></i>
            <span> Actualiser </span>
          </button>
        </div>
      </div>
    </form>
    <br />
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col">Nº</th>
          <th scope="col">Désignation</th>
          <th scope="col">Prix TTC</th>
          <th scope="col">Quantité</th>
          <th scope="col">Total TTC</th>
          <th scope="col">Remarque</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in saleItems" :key="index++">
          <td>
            {{ index }}
          </td>

          <td>
            <span v-if="item.item && item.item.fullName">
              {{ item.item.fullName }}
            </span>
            <span v-else-if="item.itemFullName">
              {{ item.itemFullName }}
            </span>
          </td>

          <td class="">
            <span v-if="item.priceTTC != null">
              {{ item.priceTTC }}
            </span>
          </td>

          <td class="">
            <span v-if="item.quantity != null">
              {{ item.quantity }}
            </span>
            <span v-if="item.item && item.item.measuring">
              {{ item.item.measuring }}
            </span>
            <span v-else-if="item.itemMeasuring">
              {{ item.itemMeasuring }}
            </span>
          </td>
          <td class="">
            <span v-if="item.totalPriceTTC != null">
              {{ item.totalPriceTTC }}
            </span>
          </td>

          <td>
            {{ item.remark }}
          </td>

          <td class="d-flex">
            <button @click="remove(item)" class="btn text-danger">
              <i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="border-0">
          <td></td>

          <td>Total :</td>
          <td class=""></td>
          <td>
            <span class="fw-bold bg-warning px-2 py-1 rounded">
              {{ parseFloat(totalQuantityItems).toFixed(2) }}
            </span>
          </td>
          <td>
            <span class="fw-bold bg-warning px-2 py-1 rounded">
              {{ parseFloat(totalPriceTTCItems).toFixed(2) }}
            </span>
            DH
          </td>

          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tfoot>
    </table>
    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-xl-8 col-12"></div>
      <div class="col-xl-auto col-12">
        <button class="btn btn-primary" @click="next()">
          <i class="bi bi-arrow-right-circle"></i> Suivant
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      saleItem: {
        item_reference: "",
        stock_reference: "",
        quantity: "",
        priceTTC: "",
        pcs: "",
      },
      section_reference: null,
      item_reference: null,
      itemCode: null,
      accept: false,
      customer_change: true,
      showError: false,
      errorFields: [],
      order_reference: "",
      selectedItem: {},
    };
  },
  computed: {
    ...mapGetters("item", {
      items: "getAll",
    }),
    ...mapGetters("section", {
      sections: "getAll",
    }),
    ...mapGetters("customer", {
      customers: "getAll",
    }),
    ...mapGetters("sale", {
      saleItems: "getItems",
      totalQuantityItems: "totalQuantityItems",
      totalPriceTTCItems: "totalPriceTTCItems",
      numberItems: "numberItems",
      errors: "getErrors",
    }),
    ...mapGetters("order", {
      orders: "getAll",
    }),
    ...mapGetters("stock", {
      stockItems: "getStockItems",
    }),

    filteredStockItems() {
      if (this.saleItem.item_reference)
        return this.stockItems.filter(
          (stockItem) =>
            stockItem.item_reference == this.saleItem.item_reference
        );
      return null;
    },

    filteredItems() {
      if (this.section_reference == null) {
        return this.items;
      }

      return this.items.filter(
        (item) => item.section_reference == this.section_reference
      );
    },
    singlePurchasePriceTTC() {
      if (this.filteredStockItems && this.filteredStockItems.length === 1) {
        return this.filteredStockItems[0].purchasePriceTTC;
      }
      return "";
    },
    isMultipleStock() {
      // Safely check if stock setting is 'multiple'
      if (this.$settings && this.$settings.stock) {
        return this.$settings.stock === "multiple";
      }
      // Fallback: use $setting function if available
      if (this.$setting && typeof this.$setting === "function") {
        const stockValue = this.$setting("stock");
        return stockValue === "multiple";
      }
      // Default to false (single stock mode)
      return false;
    },
    shouldCalculateStock() {
      // Safely check if calculate_stock setting is true
      if (this.$settings && this.$settings.calculate_stock !== undefined) {
        return (
          this.$settings.calculate_stock === true ||
          this.$settings.calculate_stock === "true" ||
          this.$settings.calculate_stock === 1
        );
      }
      // Fallback: use $setting function if available
      if (this.$setting && typeof this.$setting === "function") {
        const calculateStockValue = this.$setting("calculate_stock");
        return (
          calculateStockValue === true ||
          calculateStockValue === "true" ||
          calculateStockValue === 1
        );
      }
      // Default to false
      return false;
    },
    shouldShowStockQuantity() {
      // Show stock quantity if stock setting is 'multiple' or 'individual' (not 'disabled')
      if (!this.saleItem.item_reference) {
        return false;
      }

      let stockValue = "";
      if (this.$settings && this.$settings.stock) {
        stockValue = this.$settings.stock;
      } else if (this.$setting && typeof this.$setting === "function") {
        stockValue = this.$setting("stock") || "";
      }

      // Show if stock is 'multiple' or 'individual' (not 'disabled' or empty)
      return stockValue === "multiple" || stockValue === "individual";
    },
    availableStockQuantity() {
      // Calculate total available stock quantity for selected item from database
      if (!this.shouldShowStockQuantity || !this.saleItem.item_reference) {
        return null;
      }

      if (!this.filteredStockItems || this.filteredStockItems.length === 0) {
        return 0;
      }

      // If multiple stock mode and a stock is selected, show total of all stocks
      // If single stock mode, show total of all stocks for this item
      // Sum all quantities from filtered stock items (from database)
      const totalQuantity = this.filteredStockItems.reduce((sum, stockItem) => {
        const quantity = parseFloat(stockItem.quantity) || 0;
        return sum + quantity;
      }, 0);

      return totalQuantity.toFixed(2);
    },
    selectedStockQuantity() {
      // Get quantity of the selected stock (when multiple stocks mode)
      if (
        !this.isMultipleStock ||
        !this.saleItem.stock_reference ||
        !this.filteredStockItems
      ) {
        return null;
      }

      const selectedStock = this.filteredStockItems.find(
        (stock) => stock.reference === this.saleItem.stock_reference
      );

      if (selectedStock) {
        return parseFloat(selectedStock.quantity || 0).toFixed(2);
      }

      return null;
    },
    selectedItemMeasuring() {
      // Get measuring unit from selected item
      if (
        !this.saleItem.item_reference ||
        !this.items ||
        this.items.length === 0
      ) {
        return null;
      }

      const selectedItem = this.items.find(
        (item) => item.reference === this.saleItem.item_reference
      );
      return selectedItem && selectedItem.measuring
        ? selectedItem.measuring
        : null;
    },
    isQuantityExceedingStock() {
      // Check if entered quantity exceeds available stock
      if (
        !this.shouldShowStockQuantity ||
        this.availableStockQuantity === null
      ) {
        return false;
      }

      const enteredQuantity = parseFloat(this.saleItem.quantity) || 0;
      const availableQuantity = parseFloat(this.availableStockQuantity) || 0;

      return enteredQuantity > availableQuantity;
    },
  },
  methods: {
    validateQuantity() {
      // Cap the quantity to available stock if it exceeds
      if (this.isQuantityExceedingStock) {
        const availableQty = parseFloat(this.availableStockQuantity) || 0;
        this.saleItem.quantity = availableQty.toFixed(2);

        // Show notification
        this.$store.dispatch(
          "notification/store",
          {
            status: "warning",
            message: `La quantité a été ajustée au stock disponible: ${availableQty}`,
          },
          { root: true }
        );
      }
    },
    async save(data) {
      // Validate quantity before saving
      if (this.isQuantityExceedingStock) {
        this.validateQuantity();
        return; // Don't save if quantity exceeds stock
      }

      await this.$store.dispatch("sale/storeItem", data);
      await (this.saleItem.item_reference = "");
      await (this.saleItem.stock_reference = "");
      await (this.saleItem.quantity = "");
      await (this.saleItem.priceTTC = "");
      await (this.saleItem.pcs = "");
      await (this.section_reference = null);
      await (this.item_reference = null);
      await (this.selectedItem = {});
      await this.$store.dispatch("stock/fetchStocksItems");
    },
    async remove(data) {
      this.$store.dispatch("sale/destroyItem", data.id);
    },
    async refresh() {
      await this.$store.dispatch("stock/fetchStocksItems");
      this.$store.dispatch("section/getAll");
      this.$store.dispatch("item/getAll");
      this.$store.dispatch("sale/getAllItems");
      this.$store.dispatch("customer/getAll");
      this.$store.dispatch("order/getAll");
    },
    async next() {
      let order_reference = "";
      let customer_reference = this.saleItem.customer_reference;
      if (this.$route.query.order) order_reference = this.$route.query.order;
      if (this.$route.query.customer)
        customer_reference = this.$route.query.customer;

      this.$router.push({
        name: "sales-create",
        query: {
          customer_reference: customer_reference,
          order_reference: order_reference,
        },
      });
    },
  },
  async created() {
    await this.$store.dispatch("stock/fetchStocksItems");
    await this.$store.dispatch("section/getAll");
    await this.$store.dispatch("item/getAll");
    await this.$store.dispatch("sale/getAllItems");
    await this.$store.dispatch("customer/getAll");
    await this.$store.dispatch("order/getAll");
  },
  watch: {
    // Watch for item selection changes
    "saleItem.item_reference"(newValue, oldValue) {
      // Clear stock selection when item changes
      if (newValue !== oldValue) {
        this.saleItem.stock_reference = "";
        // Refresh stock items to get latest data from database
        this.$store.dispatch("stock/fetchStocksItems");
      }
      // Set priceTTC when item is selected (like order items)
      if (newValue) {
        this.selectedItem =
          this.filteredItems.find((item) => item.reference === newValue) || {};
        this.saleItem.priceTTC = parseFloat(this.selectedItem.priceTTC) || "";
      }
    },
    "saleItem.pcs": function (newValue, oldValue) {
      // Only calculate if pcs changed and we have the necessary data
      if (newValue !== oldValue && newValue && this.selectedItem.pcs) {
        // Calculate quantity from pcs: quantity = pcs / item.pcs
        const calculatedQuantity = parseFloat(
          newValue / this.selectedItem.pcs
        ).toFixed(2);
        // Only update if the calculated value is different to avoid infinite loop
        if (this.saleItem.quantity !== calculatedQuantity) {
          this.saleItem.quantity = calculatedQuantity;
        }
      }
    },
    "saleItem.quantity": function (newValue, oldValue) {
      // Only calculate if quantity changed and we have the necessary data
      if (newValue !== oldValue && newValue && this.selectedItem.pcs) {
        // Calculate pcs from quantity: pcs = quantity * item.pcs (always integer)
        const calculatedPcs = Math.round(
          parseFloat(newValue * this.selectedItem.pcs)
        );
        // Only update if the calculated value is different to avoid infinite loop
        if (this.saleItem.pcs != calculatedPcs) {
          this.saleItem.pcs = calculatedPcs;
        }
      }
    },
  },
  filters: {
    date: (value) => {
      return moment(value).format("DD-MM-YYYY");
    },
  },
};
</script>
